var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { class: "footerFixed" };
const _hoisted_3 = {
    id: "all_wrapper",
    class: "payment_entry"
};
const _hoisted_4 = { class: "wrapper_1" };
const _hoisted_5 = { class: "inner" };
const _hoisted_6 = { class: "" };
const _hoisted_7 = {
    key: 0,
    style: { "margin-top": "40px", "padding": "20px 40px", "border": "solid 1px red" }
};
const _hoisted_8 = { style: { "color": "red", "font-size": "19px", "margin": "40px 0px" } };
const _hoisted_9 = {
    key: 1,
    style: { "color": "red", "font-size": "19px", "margin": "40px 0px" }
};
const _hoisted_10 = {
    id: "pay-modal",
    class: "modal type3 js-modal"
};
const _hoisted_11 = { class: "modal-content" };
const _hoisted_12 = { class: "close_bt" };
const _hoisted_13 = {
    key: 0,
    class: "pop"
};
const _hoisted_14 = {
    key: 1,
    class: "pop"
};
const _hoisted_15 = { class: "spinner-container" };
const _hoisted_16 = { class: "spinner" };
const _hoisted_17 = { key: 1 };
const _hoisted_18 = { class: "footerFixed" };
const _hoisted_19 = { class: "loading-container" };
const _hoisted_20 = { class: "spinner-container" };
const _hoisted_21 = { class: "spinner" };
const _hoisted_22 = { class: "message-box" };
import { inject, ref, reactive, computed, onMounted, nextTick } from 'vue';
import { Inertia } from '@inertiajs/inertia';
import headerVue from '@layout/header.vue';
import footerVue from '@layout/footer.vue';
import Formatter from '@util/Formatter';
import StripeForm from '@component/PaymentForm.vue';
import ImageFrame from '@component/ImageFrame.vue';
import swal from 'sweetalert';
import { loadStripe } from '@stripe/stripe-js';
/**
 * 支払方法登録画面
 *
 * - クレジットカードの登録・変更（stripe-form モーダル）
 * - 今月分の基本料金のお支払い（月次バッチで決済が完了しなかった分の手動支払い）
 *     赤枠の［基本料金のお支払い］→ 確認モーダル（#pay-modal）→ POST /main_plan_pay
 *     → payment_confirm（Stripe の 3DS 認証画面へ自動遷移）→ return_url（/payment）に戻る
 *     → 戻り先で PaymentIntent の状態を見て 3 分岐（決済完了／本人確認失敗／カード拒否）
 *   `?pay=1` 付きで開いたとき（メールのリンク・カード変更後）は確認モーダルを自動で開く
 */
// 'loading' のあいだはページを隠してローディング表示にする
export default /*@__PURE__*/ _defineComponent({
    __name: 'payment_entry',
    props: {
        common: {},
        payment: {},
        plan_id: {},
        card_id: {},
        create_question_available: { type: Boolean },
        payment_intent_client_secret: {},
        pay_plan: {},
        pay_now: { type: Boolean },
        pay_error: {},
        pay_message: {}
    },
    setup(__props) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const auth_3ds_complete = ref('ready');
        const loadingTitle = ref('決済状態を確認中です');
        const props = __props;
        const form = reactive({
            payment_card_number: (_b = (_a = props.payment) === null || _a === void 0 ? void 0 : _a.payment_card_number) !== null && _b !== void 0 ? _b : '',
            payment_card_brand: (_d = (_c = props.payment) === null || _c === void 0 ? void 0 : _c.payment_card_brand) !== null && _d !== void 0 ? _d : '',
            payment_card_expire_month: (_f = (_e = props.payment) === null || _e === void 0 ? void 0 : _e.payment_card_expire_month) !== null && _f !== void 0 ? _f : '',
            payment_card_expire_year: (_h = (_g = props.payment) === null || _g === void 0 ? void 0 : _g.payment_card_expire_year) !== null && _h !== void 0 ? _h : '',
        });
        const stripeBtn = ref();
        const payBtn = ref();
        const showPayLoading = ref(false);
        const showLimitDate = computed(() => {
            const month = form.payment_card_expire_month;
            const year = form.payment_card_expire_year;
            if (month && year) {
                return Formatter.formatDate(`${year}/${month}/01`, 'MM/YYYY');
            }
            return '未登録';
        });
        const showCardNumber = computed(() => {
            if (form.payment_card_number) {
                return '**** **** **** ' + form.payment_card_number.slice(-4);
            }
            return '未登録';
        });
        // 確認モーダル用（ブランド + 下4桁）
        const showCardSummary = computed(() => {
            if (!form.payment_card_number) {
                return '未登録';
            }
            const brand = form.payment_card_brand ? `${form.payment_card_brand} ` : '';
            return `${brand}**** ${form.payment_card_number.slice(-4)}（有効期限 ${showLimitDate.value}）`;
        });
        const showMonthlyFee = computed(() => { var _a, _b; return ((_b = (_a = props.pay_plan) === null || _a === void 0 ? void 0 : _a.monthly_fee) !== null && _b !== void 0 ? _b : 0).toLocaleString(); });
        // カード登録・変更モーダル（stripe-form）を開く
        const openCardModal = () => {
            var _a;
            (_a = stripeBtn.value) === null || _a === void 0 ? void 0 : _a.click();
        };
        // 今月分のお支払いを実行する（旧 PaymentIntent の取消・新規作成はサーバ側）
        const postMainPlanPay = () => {
            Inertia.post(route('payment.main_plan_pay'), {}, {
                // Inertia の POST は既定で preserveState: true（コンポーネントを作り直さない）。
                // 結果は /payment へのリダイレクト後の props（pay_error / pay_message / client_secret）で判定するので、
                // 作り直して onMounted を再実行させる
                preserveState: false,
                onError: () => {
                    showPayLoading.value = false;
                    auth_3ds_complete.value = 'ready';
                    loadModalPlugin();
                },
                // 通信エラー・500 などで画面が切り替わらなかった場合も「決済処理中」のままにしない
                onFinish: () => {
                    if (showPayLoading.value || auth_3ds_complete.value === 'loading') {
                        showPayLoading.value = false;
                        auth_3ds_complete.value = 'ready';
                        loadModalPlugin();
                    }
                },
            });
        };
        // 確認モーダルの［OK］
        const onClickPayOk = () => {
            if (showPayLoading.value)
                return;
            showPayLoading.value = true;
            postMainPlanPay();
        };
        // 本人確認失敗ダイアログの［もう一度認証する］
        const retryPay = () => {
            loadingTitle.value = '決済処理中です';
            auth_3ds_complete.value = 'loading';
            postMainPlanPay();
        };
        const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));
        // processing のあいだ最大 10 秒ポーリングする
        const pollPaymentStatus = (stripe, clientSecret) => __awaiter(this, void 0, void 0, function* () {
            let paymentIntent = null;
            for (let i = 0; i < 10; i++) {
                yield sleep(1000);
                ({ paymentIntent } = yield stripe.retrievePaymentIntent(clientSecret));
                if (paymentIntent.status === 'succeeded') {
                    return { result: 'succeeded', paymentIntent };
                }
                if (paymentIntent.status === 'requires_payment_method' || paymentIntent.status === 'canceled') {
                    return { result: 'payment_failed', paymentIntent };
                }
            }
            return { result: 'timeout', paymentIntent };
        });
        // 本人認証（3DS）が完了しなかったときのエラーコード（カード自体は使える）
        const AUTH_ERROR_CODES = ['payment_intent_authentication_failure', 'authentication_required'];
        const isAuthFailure = (paymentIntent) => {
            var _a, _b;
            const code = (_b = (_a = paymentIntent === null || paymentIntent === void 0 ? void 0 : paymentIntent.last_payment_error) === null || _a === void 0 ? void 0 : _a.code) !== null && _b !== void 0 ? _b : '';
            // 認証画面を閉じた・中断した場合は last_payment_error が無いことがある → 認証失敗として扱う
            return code === '' || AUTH_ERROR_CODES.includes(code);
        };
        // 決済完了（説明文は黒 .pay-done-dialog）→ OK でホームへ
        const showPaymentDone = () => {
            return swal({
                title: '決済完了',
                text: '今月の基本料金のお支払いが完了しました。',
                icon: 'success',
                className: 'pay-done-dialog',
                closeOnClickOutside: false,
                closeOnEsc: false,
                buttons: {
                    ok: {
                        text: 'OK',
                        className: 'timeout-ok-btn',
                    },
                },
            }).then(() => {
                Inertia.get(route('question.index'));
            });
        };
        // 本人確認（3DS）失敗 → ［カードの変更］／［もう一度認証する］
        const show3dsFailed = () => {
            return swal({
                title: '確認',
                text: '本人確認(3Dセキュア)に失敗しました。',
                icon: 'warning',
                className: 'pay-retry-dialog',
                closeOnClickOutside: false,
                closeOnEsc: false,
                buttons: {
                    cancel: {
                        text: 'カードの変更',
                        value: 'card',
                        visible: true,
                        className: 'pay-alt-btn',
                    },
                    confirm: {
                        text: 'もう一度認証する',
                        value: 'retry',
                        className: 'timeout-ok-btn',
                    },
                },
            }).then((value) => {
                if (value === 'retry') {
                    retryPay();
                }
                else {
                    openCardModal();
                }
            });
        };
        // カード拒否（有効期限切れ・限度額超過など）→ ［カードの変更］
        const showCardDeclined = () => {
            return swal({
                title: '確認',
                text: 'このカードは使用できません',
                icon: 'warning',
                closeOnClickOutside: false,
                closeOnEsc: false,
                buttons: {
                    ok: {
                        text: 'カードの変更',
                        className: 'timeout-ok-btn',
                    },
                },
            }).then(() => {
                openCardModal();
            });
        };
        const showPaymentResult = (title, message, icon) => {
            return swal({
                title: title,
                text: message,
                icon: icon,
                buttons: {
                    ok: {
                        text: 'OK',
                        className: 'timeout-ok-btn',
                    },
                },
            });
        };
        // jQuery のモーダルプラグイン（.modal_win / .bt_modal_close）を読み込む。
        // v-if で DOM を作り直したあとは再読み込みが必要
        const loadModalPlugin = () => __awaiter(this, void 0, void 0, function* () {
            yield nextTick();
            // 既に読み込まれていたら一旦削除して、読み込み直す。
            var key = require.resolve('@jquery/modal-jquery');
            if (key)
                delete require.cache[key];
            require('@jquery/modal-jquery');
        });
        onMounted(() => __awaiter(this, void 0, void 0, function* () {
            var _j;
            const publishableKey = inject('stripePublicKey', '');
            let stripeInstance = null;
            if (publishableKey && typeof publishableKey === 'string') {
                // Stripe公開鍵でStripeを初期化
                stripeInstance = yield loadStripe(publishableKey);
                if (!stripeInstance) {
                    console.error('Failed to load Stripe');
                }
            }
            else {
                console.error('Stripe API key is not available or invalid type');
            }
            // Check for 3DS2 return
            // （サーバー側でクエリをセッション flash に退避してクリーンな URL にリダイレクトするため、
            //   通常は props 経由で受け取る。URL に残っている場合も拾う）
            const params = new URLSearchParams(window.location.search);
            const clientSecret = props.payment_intent_client_secret || params.get('payment_intent_client_secret');
            // 戻り先での判定結果: 'done' | '3ds_failed' | 'declined' | 'timeout' | 'error' | null
            let outcome = null;
            if (clientSecret && stripeInstance) {
                auth_3ds_complete.value = 'loading';
                try {
                    const { paymentIntent } = yield stripeInstance.retrievePaymentIntent(clientSecret);
                    if (paymentIntent.status === 'succeeded') {
                        outcome = 'done';
                    }
                    else if (paymentIntent.status === 'processing') {
                        const { result, paymentIntent: latest } = yield pollPaymentStatus(stripeInstance, clientSecret);
                        if (result === 'succeeded') {
                            outcome = 'done';
                        }
                        else if (result === 'payment_failed') {
                            outcome = isAuthFailure(latest) ? '3ds_failed' : 'declined';
                        }
                        else {
                            outcome = 'timeout';
                        }
                    }
                    else if (paymentIntent.status === 'requires_payment_method' || paymentIntent.status === 'canceled') {
                        // 3DS2 認証失敗・中断、またはカード拒否
                        outcome = isAuthFailure(paymentIntent) ? '3ds_failed' : 'declined';
                    }
                    else if (paymentIntent.status === 'requires_action') {
                        // 認証画面に行かずに戻ってきた → 認証失敗と同じ扱い（もう一度認証する）
                        outcome = '3ds_failed';
                    }
                }
                catch (error) {
                    console.error('Error checking payment status:', error);
                    outcome = 'error';
                }
            }
            auth_3ds_complete.value = 'ready';
            yield loadModalPlugin();
            if (!props.payment) {
                // カード未登録 → 支払方法登録モーダルを開く
                stripeBtn.value.click();
                return;
            }
            switch (outcome) {
                case 'done':
                    showPaymentDone();
                    return;
                case '3ds_failed':
                    show3dsFailed();
                    return;
                case 'declined':
                    showCardDeclined();
                    return;
                case 'timeout':
                    showPaymentResult('決済処理中', '決済処理に時間がかかっています。しばらく経ってからマイページをご確認ください。', 'warning');
                    return;
                case 'error':
                    showPaymentResult('確認', '決済状態の確認中にエラーが発生しました。', 'warning');
                    return;
            }
            if (props.pay_error) {
                // POST /main_plan_pay でカード拒否
                showCardDeclined();
                return;
            }
            if (props.pay_message) {
                showPaymentResult('確認', props.pay_message, 'info');
                return;
            }
            if (props.pay_now && props.pay_plan && !props.create_question_available) {
                // ?pay=1（メールのリンク・カード変更後）→ 確認モーダルを自動で開く
                (_j = payBtn.value) === null || _j === void 0 ? void 0 : _j.click();
            }
        }));
        return (_ctx, _cache) => {
            var _a, _b;
            return (auth_3ds_complete.value !== 'loading')
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(headerVue, {
                        common: props.common
                    }, null, 8, ["common"]),
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _cache[6] || (_cache[6] = _createElementVNode("h2", null, "支払方法登録", -1)),
                                _createElementVNode("div", _hoisted_5, [
                                    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "text-start" }, [
                                        _createElementVNode("h4", { style: { "text-align": "start" } }, "現在ご登録されているクレジットカード")
                                    ], -1)),
                                    _createElementVNode("form", null, [
                                        _createElementVNode("dl", null, [
                                            _cache[0] || (_cache[0] = _createElementVNode("dt", null, "カード番号", -1)),
                                            _createElementVNode("dd", null, _toDisplayString(showCardNumber.value), 1),
                                            _cache[1] || (_cache[1] = _createElementVNode("dt", null, "有効期限", -1)),
                                            _createElementVNode("dd", null, _toDisplayString(showLimitDate.value), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_6, [
                                            _createElementVNode("a", {
                                                id: "payment-change-btn",
                                                class: "bt_change modal_win",
                                                "data-target": "payment-modal",
                                                ref_key: "stripeBtn",
                                                ref: stripeBtn
                                            }, _toDisplayString(props.payment ? 'カードの変更' : '支払方法登録'), 513)
                                        ])
                                    ]),
                                    (!_ctx.$props.create_question_available)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                            (props.pay_plan)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                    _createElementVNode("span", _hoisted_8, [
                                                        _createTextVNode(" 今月分（" + _toDisplayString(props.pay_plan.target_month) + "分）の基本料金のお支払いが完了していないため、相談の投稿ができません。下のボタンからお支払いを完了してください。", 1),
                                                        _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
                                                        _cache[3] || (_cache[3] = _createTextVNode(" ※カードが利用できない場合は、先に「カードの変更」を行ってください。 "))
                                                    ]),
                                                    _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
                                                    _createElementVNode("a", {
                                                        style: { "margin-top": "20px" },
                                                        class: "bt_change modal_win",
                                                        "data-target": "pay-modal",
                                                        ref_key: "payBtn",
                                                        ref: payBtn
                                                    }, "基本料金のお支払い", 512)
                                                ], 64))
                                                : (_openBlock(), _createElementBlock("span", _hoisted_9, " 今月分の基本料金のお支払いが完了していないため、相談の投稿ができません。 "))
                                        ]))
                                        : _createCommentVNode("", true)
                                ])
                            ])
                        ]),
                        _createVNode(footerVue)
                    ]),
                    _createElementVNode("form", null, [
                        _createVNode(StripeForm, {
                            payment_intent_client_secret: props.payment_intent_client_secret,
                            plan_id: props.plan_id
                        }, null, 8, ["payment_intent_client_secret", "plan_id"])
                    ]),
                    _createElementVNode("form", null, [
                        _createElementVNode("div", _hoisted_10, [
                            _cache[16] || (_cache[16] = _createElementVNode("div", { class: "modal-bg" }, null, -1)),
                            _createElementVNode("div", _hoisted_11, [
                                _createElementVNode("div", _hoisted_12, [
                                    _createVNode(ImageFrame, {
                                        src: "images/common/i_bt_close.svg",
                                        class: "bt_modal_close"
                                    })
                                ]),
                                (!showPayLoading.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                        _cache[12] || (_cache[12] = _createElementVNode("h2", null, "今月分のお支払い", -1)),
                                        _cache[13] || (_cache[13] = _createElementVNode("h3", null, "以下の内容でお支払いします", -1)),
                                        _createElementVNode("dl", null, [
                                            _cache[7] || (_cache[7] = _createElementVNode("dt", null, "対象", -1)),
                                            _createElementVNode("dd", null, _toDisplayString((_a = props.pay_plan) === null || _a === void 0 ? void 0 : _a.target_month) + "分", 1),
                                            _cache[8] || (_cache[8] = _createElementVNode("dt", null, "料金プラン", -1)),
                                            _createElementVNode("dd", null, _toDisplayString((_b = props.pay_plan) === null || _b === void 0 ? void 0 : _b.name) + "プラン", 1),
                                            _cache[9] || (_cache[9] = _createElementVNode("dt", null, "お支払い金額", -1)),
                                            _createElementVNode("dd", null, _toDisplayString(showMonthlyFee.value) + "円(税込)", 1),
                                            _cache[10] || (_cache[10] = _createElementVNode("dt", null, "お支払いカード", -1)),
                                            _createElementVNode("dd", null, _toDisplayString(showCardSummary.value), 1)
                                        ]),
                                        _cache[14] || (_cache[14] = _createElementVNode("p", {
                                            class: "lead",
                                            style: { "margin-top": "20px" }
                                        }, " ※「OK」を押すと、クレジットカード会社の本人認証（3Dセキュア）画面に移動します。認証が完了するとお支払いが確定し、相談の投稿が可能になります。 ", -1)),
                                        _createElementVNode("div", { class: "bt_box clear" }, [
                                            _createElementVNode("ul", { class: "modalBtn-area b2" }, [
                                                _cache[11] || (_cache[11] = _createElementVNode("li", null, [
                                                    _createElementVNode("p", { class: "bt_modal_close bt_clear" }, "キャンセル")
                                                ], -1)),
                                                _createElementVNode("li", null, [
                                                    _createElementVNode("button", {
                                                        type: "button",
                                                        class: "bt_ok",
                                                        onClick: onClickPayOk
                                                    }, "OK")
                                                ])
                                            ])
                                        ])
                                    ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                        _createElementVNode("div", _hoisted_15, [
                                            _createElementVNode("div", _hoisted_16, [
                                                _createVNode(ImageFrame, { src: "images/index/loading.gif" })
                                            ]),
                                            _cache[15] || (_cache[15] = _createElementVNode("div", { class: "message-box" }, [
                                                _createElementVNode("p", null, [
                                                    _createElementVNode("strong", null, "現在決済処理中です")
                                                ]),
                                                _createElementVNode("p", null, "ボタンを押したり移動したりせず、このまましばらくお待ちください。処理が完了したら自動的に画面が変わります。")
                                            ], -1))
                                        ])
                                    ]))
                            ])
                        ])
                    ])
                ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createVNode(headerVue, {
                        common: props.common
                    }, null, 8, ["common"]),
                    _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("div", _hoisted_20, [
                                _createElementVNode("div", _hoisted_21, [
                                    _createVNode(ImageFrame, { src: "images/index/loading.gif" })
                                ]),
                                _createElementVNode("div", _hoisted_22, [
                                    _createElementVNode("p", null, [
                                        _createElementVNode("strong", null, _toDisplayString(loadingTitle.value), 1)
                                    ]),
                                    _cache[17] || (_cache[17] = _createElementVNode("p", null, "しばらくお待ちください...", -1))
                                ])
                            ])
                        ]),
                        _createVNode(footerVue)
                    ])
                ]));
        };
    }
});
